import { render, staticRenderFns } from "./myClues.vue?vue&type=template&id=9f0c952c&scoped=true&lang=html&"
import script from "./myClues.vue?vue&type=script&lang=js&"
export * from "./myClues.vue?vue&type=script&lang=js&"
import style0 from "./myClues.vue?vue&type=style&index=0&id=9f0c952c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c952c",
  null
  
)

component.options.__file = "myClues.vue"
export default component.exports